import React from "react";
const IconSort = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10 13.7438L6 17.5M6 17.5L2 13.7438M6 17.5L6 3.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <path
      d="M10 6.25621L14 2.5M14 2.5L18 6.25621M14 2.5L14 16.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconSort;
